import { render } from "./FeeRebateForm.vue?vue&type=template&id=2d0b1897&ts=true"
import script from "./FeeRebateForm.vue?vue&type=script&lang=ts"
export * from "./FeeRebateForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__